import { $ } from "./utilities/$";
import { Tools } from "./utilities/Tools";
import { Alert } from "./components/Alert";
import { ModalDialog } from "./core/ModalDialog";
import { Ajax } from "./core/Ajax";
import { Multiple } from "./components/form/Multiple";
import { Autocomplete } from "./components/form/Autocomplete";
import { Dialog } from "./components/Dialog";
import { ProjectsCalendar } from "./components/projects-calendar/ProjectsCalendar";
import { TableCaption } from "./components/TableCaption";
import { Switch } from "./components/form/Switch";
import { DragAndDrop } from "./core/drag-and-drop/DragAndDrop";
import { DragAndDropMobile } from "./core/drag-and-drop/DragAndDropMobile";
import { DragAndDropFiles } from "./core/drag-and-drop/drag-and-drop-files/DragAndDropFiles";
import { Preloader } from "./components/Preloader";

class Iksoris {
    constructor() {
        this.$ = $;
        this.Tools = Tools;
        this.Alert = Alert;
        this.ModalDialog = ModalDialog;
        this.Ajax = Ajax;
        this.Dialog = Dialog;
        this.Multiple = Multiple;
        this.Autocomplete = Autocomplete;
        this.ProjectsCalendar = ProjectsCalendar;
        this.DragAndDropFiles = DragAndDropFiles;
        this.Preloader = Preloader;
    }

    /**
     * Multiple
     */
    createMultiple() {
        const multipleSelectElementList = [].slice.call(document.querySelectorAll('select[data-toggle="multiple"]'));

        if (multipleSelectElementList.length > 0) {
            const multipleSelectList = multipleSelectElementList.map(function (select) {
                let isInstanceExistsForNode = select.dataset.jsNodeInstance;

                // Sprawdzamy czy element posiada atrybut [data-js-node-instance="true"]. Jeśli nie posiada to ustawiamy atrybut i tworzymy instancje dla elementu.
                if (!Boolean(isInstanceExistsForNode)) {
                    select.setAttribute("data-js-node-instance", true);

                    // Tworzenie pseudoselecta dla selectów posiadajacych atrybut data-toggle="multiple"
                    return new Multiple(select);
                }
            });
        }
    }

    /**
     * Multiple
     */
    createAutocomplete() {
        const autocompleteInputElementList = [].slice.call(document.querySelectorAll('input[data-toggle="autocomplete"]'));

        if (autocompleteInputElementList.length > 0) {
            const autocompleteInputList = autocompleteInputElementList.map(function (input) {
                let isInstanceExistsForNode = input.dataset.jsNodeInstance;

                // Sprawdzamy czy element posiada atrybut [data-js-node-instance="true"]. Jeśli nie posiada to ustawiamy atrybut i tworzymy instancje dla elementu.
                if (!Boolean(isInstanceExistsForNode)) {
                    input.setAttribute("data-js-node-instance", true);

                    // Tworzenie Autocomplete
                    return new Autocomplete(input);
                }
            });
        }
    }

    /**
     * Dialog
     */
    createDialog() {
        const dialogElementList = [].slice.call(document.querySelectorAll('[data-toggle="dialog"]'));

        if (dialogElementList.length > 0) {
            const dialogList = dialogElementList.map(function (toggle) {
                let isInstanceExistsForNode = toggle.dataset.jsNodeInstance;

                // Sprawdzamy czy element posiada atrybut [data-js-node-instance="true"]. Jeśli nie posiada to ustawiamy atrybut i tworzymy instancje dla elementu.
                if (!Boolean(isInstanceExistsForNode)) {
                    toggle.setAttribute("data-js-node-instance", true);

                    // Tworzenie Dialog
                    return new Dialog(toggle);
                }
            });
        }
    }

    /**
     * Projects Calendar
     */
    createProjectsCalendar() {
        const projectsCalendarElementList = [].slice.call(document.querySelectorAll('[data-toggle="projects-calendar"]'));

        if (projectsCalendarElementList.length > 0) {
            const projectsCalendarList = projectsCalendarElementList.map(function (calendar) {
                let isInstanceExistsForNode = calendar.dataset.jsNodeInstance;

                // Sprawdzamy czy element posiada atrybut [data-js-node-instance="true"]. Jeśli nie posiada to ustawiamy atrybut i tworzymy instancje dla elementu.
                if (!Boolean(isInstanceExistsForNode)) {
                    calendar.setAttribute("data-js-node-instance", true);

                    // Tworzenie ProjectsCalendar
                    return new ProjectsCalendar(calendar);
                }
            });
        }
    }

    /**
     * Drag and drop
     */
    createDragAndDrop() {
        const dragAndDropElementList = [...document.querySelectorAll('select[data-toggle="dragAndDrop"]')];

        if (dragAndDropElementList.length > 0) {
            const dragAndDropList = dragAndDropElementList.map(function (select) {
                let isInstanceExistsForNode = select.dataset.jsNodeInstance;

                // Sprawdzamy czy element posiada atrybut [data-js-node-instance="true"]. Jeśli nie posiada to ustawiamy atrybut i tworzymy instancje dla elementu.
                if (!Boolean(isInstanceExistsForNode)) {
                    select.setAttribute("data-js-node-instance", true);

                    if ("ontouchstart" in document) {
                        return new DragAndDropMobile(select);
                    } else {
                        return new DragAndDrop(select);
                    }
                }
            });
        }
    }

    /**
     * Drag and drop files
     */
    createDragAndDropFiles() {
        const dragAndDropFilesElementList = [...document.querySelectorAll('input[data-toggle="dragAndDropFiles"]')];

        if (dragAndDropFilesElementList.length > 0) {
            const dragAndDropFilesList = dragAndDropFilesElementList.map(function (input) {
                let isInstanceExistsForNode = input.dataset.jsNodeInstance;

                // Sprawdzamy czy element posiada atrybut [data-js-node-instance="true"]. Jeśli nie posiada to ustawiamy atrybut i tworzymy instancje dla elementu.
                if (!Boolean(isInstanceExistsForNode)) {
                    input.setAttribute("data-js-node-instance", true);

                    // Tworzenie DragAndDropFiles
                    return new DragAndDropFiles(input);
                }
            });
        }
    }

    /**
     * TableCaption
     */
    createTableCaption() {
        const tableCaptionList = [].slice.call(document.querySelectorAll('[data-toggle="table-caption"]'));

        if (tableCaptionList.length > 0) {
            const tableCaption = tableCaptionList.map(function (element) {
                let isInstanceExistsForNode = element.dataset.jsNodeInstance;

                // Sprawdzamy czy element posiada atrybut [data-js-node-instance="true"]. Jeśli nie posiada to ustawiamy atrybut i tworzymy instancje dla elementu.
                if (!Boolean(isInstanceExistsForNode)) {
                    element.setAttribute("data-js-node-instance", true);

                    // Tworzenie TableCaption
                    return new TableCaption(element);
                }
            });
        }
    }

    /**
     * Switch
     */
    createSwitch() {
        const switchCheckboxList = [].slice.call(document.querySelectorAll('[data-toggle="switch"]'));

        if (switchCheckboxList.length > 0) {
            const switchCheckboxes = switchCheckboxList.map(function (switchCheckbox) {
                let isInstanceExistsForNode = switchCheckbox.dataset.jsNodeInstance;

                // Sprawdzamy czy element posiada atrybut [data-js-node-instance="true"]. Jeśli nie posiada to ustawiamy atrybut i tworzymy instancje dla elementu.
                if (!Boolean(isInstanceExistsForNode)) {
                    switchCheckbox.setAttribute("data-js-node-instance", true);

                    // Tworzenie TableCaption
                    return new Switch(switchCheckbox);
                }
            });
        }
    }

    /**
     * Funkcja pobierająca instancję
     */
    getInstance(key = undefined) {
        if (!key) {
            throw new Error("Wymagane jest podanie nazwy klucza dla mapy. Nazwy są widoczne w obiekcie: iksoris.instances.");
        }

        return iksoris.instances.get(key);
    }

    /**
     * Przeładowanie
     */
    reloadInstances() {
        this.createMultiple();
        this.createAutocomplete();
        this.createDialog();
        this.createProjectsCalendar();
        this.createDragAndDrop();
        this.createTableCaption();
        this.createSwitch();

        //
        // if (Boolean(document.getElementById("dialog"))) {
        //     // Ustawienie Datepicker Widget dla pól wyboru daty wewnątrz okna dialog. Przed wczytaniem okna Datepicker Widget dla pola następuje przeniesienie do wnętrza #dialog (usunięcie błędu związanego z niewyświetlaniem select's pod Firefox).
        //     jQuery("input.form-field-date").datepicker({
        //         beforeShow: function (input, instance) {
        //             jQuery("#dialog").append(jQuery("#ui-datepicker-div"));
        //         },
        //     });
        // } else {
        //     // Ustawienie Datepicker Widget dla pól wyboru daty poza oknem dialog.
        //     jQuery("input.form-field-date").datepicker();
        // }
    }
}

export { Iksoris };
